import { Box, Paper, Skeleton } from "@mui/material";
import LocationTreeRowsSkeleton from "./LocationTreeRowsSkeleton";

export default function LocationMapSkeleton() {
  return (
    <Box
      sx={{
        display: "flex",
        height: "calc(100vh - 106px)",
        minHeight: 0,
        overflow: "hidden",
        gap: 1.5,
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: { xs: "100%", md: 300 },
          minWidth: { xs: "auto", md: 300 },
          maxHeight: { xs: 250, md: "none" },
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          border: "1px solid #e8ecf0",
          borderRadius: 3,
        }}
      >
        <Box
          sx={{
            px: 1.5,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 1,
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Skeleton variant="text" width={80} height={22} sx={{ flex: 1 }} />
          <Skeleton variant="rounded" width={48} height={28} />
          <Skeleton variant="rounded" width={72} height={30} />
        </Box>
        <Box sx={{ px: 1.5, py: 1, borderBottom: "1px solid #f0f0f0" }}>
          <Skeleton variant="rounded" height={36} sx={{ borderRadius: 2 }} />
        </Box>
        <Box sx={{ flex: 1, overflow: "auto", py: 0.5 }}>
          <LocationTreeRowsSkeleton />
        </Box>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          border: "1px solid #e8ecf0",
          borderRadius: 3,
          p: 2,
          minHeight: { xs: 300, md: 0 },
        }}
      >
        <Skeleton variant="text" width="40%" height={28} />
        <Skeleton variant="text" width="25%" height={20} sx={{ mt: 0.5 }} />
        <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
          <Skeleton variant="rounded" width={100} height={32} />
          <Skeleton variant="rounded" width={100} height={32} />
          <Skeleton variant="rounded" width={100} height={32} />
        </Box>
        <Skeleton variant="rounded" sx={{ mt: 2, borderRadius: 2, flex: 1, minHeight: 240 }} />
      </Paper>
    </Box>
  );
}
